import { values } from 'lodash';
import { ModuleType, CharacterErrorType } from '../types';
import { ApexOptions } from 'apexcharts';

export const STARRS_LENGTH = 3;
export const LETTERS_LENGTH = 26;
export const NUMBERS_LENGTH = 10;

export const MODULE_LEVELS_COLOR_MAP = {
  [ModuleType.CAPITALS]: ['#B7E7FE', '#00B4FB', '#005596'],
  [ModuleType.LOWERCASE]: ['#99F2F0', '#00BEBA', '#005E5C'],
  [ModuleType.NUMBERS]: ['#E8D9FD', '#A06EFA', '#451D88']
};

export const MODULE_COLOR_MAP = {
  [ModuleType.CAPITALS]: [MODULE_LEVELS_COLOR_MAP[ModuleType.CAPITALS][1]],
  [ModuleType.LOWERCASE]: [MODULE_LEVELS_COLOR_MAP[ModuleType.LOWERCASE][1]],
  [ModuleType.NUMBERS]: [MODULE_LEVELS_COLOR_MAP[ModuleType.NUMBERS][1]]
};

export const MODULE_LENGTH_MAP = {
  [ModuleType.CAPITALS]: LETTERS_LENGTH,
  [ModuleType.LOWERCASE]: LETTERS_LENGTH,
  [ModuleType.NUMBERS]: NUMBERS_LENGTH
};

export const CHARACTER_ERROR_TYPE_COLOR_MAP = {
  [CharacterErrorType.MISSED_STARTING_POINT]: '#20114B',
  [CharacterErrorType.STARTED_WRONG_WAY]: '#DD4869',
  [CharacterErrorType.OUT_OF_BOUNDS]: '#8C2B81',
  [CharacterErrorType.LIFTED_FINGER]: '#F596C2',
  [CharacterErrorType.REVERSED_DIRECTION]: '#F8C084'
};

export const CHARACTER_ERROR_TYPES = values(CharacterErrorType);

export const CHARACTER_ERROR_COLORS = values(CHARACTER_ERROR_TYPE_COLOR_MAP);

export const BAR_CHART_COMMON_OPTIONS: ApexOptions = {
  yaxis: {
    tickAmount: 4,
    // offsetX: -2,
    decimalsInFloat: 0,
    forceNiceScale: true,
    title: {
      style: {
        color: '#373D3F',
        fontSize: '12px',
        fontWeight: 700,
        fontFamily: 'futura-pt'
      }
    }
  },
  xaxis: {
    labels: {
      offsetY: -4,
      style: {
        colors: '#373D3F',
        fontSize: '10px',
        fontFamily: 'futura-pt'
      }
    },
    axisTicks: { show: false }
  },
  legend: {
    showForSingleSeries: true,
    offsetY: 2,
    horizontalAlign: 'left',
    markers: { radius: 10, width: 10, height: 10 }
  },
  dataLabels: { enabled: false },
  plotOptions: {
    bar: {
      borderRadius: 5
    }
  }
};
